import {ajax,getRequestUrl,formatData} from "../request";

export default {
  // 金币道具审批 -- 审批设置列表、修改删除
  sendUidSet(data, method) {
    return ajax('post', getRequestUrl('/api/SendCoins/sendUidSet'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 金币道具审批 -- 金币发放申请列表
  sendApplyList(data, method) {
    return ajax('post', getRequestUrl('/api/SendCoins/sendApplyList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 金币道具审批 -- 金币发放申请、道具发放申请
  sendApplySave(data, method) {
    return ajax('post', getRequestUrl('/api/SendCoins/sendApplySave'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 金币道具审批 -- 金币发放申请详情、道具发放申请详情
  sendApplyInfo(data, method) {
    return ajax('post', getRequestUrl('/api/SendCoins/sendApplyInfo'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 金币道具审批 -- 金币发放申请删除、道具发放申请删除
  sendApplyDelete(data, method) {
    return ajax('post', getRequestUrl('/api/SendCoins/sendApplyDelete'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 金币道具审批 -- 金币发放审批列表、道具发放审批列表
  sendApplyReviewList(data, method) {
    return ajax('post', getRequestUrl('/api/SendCoins/sendApplyReviewList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 金币道具审批 -- 金币发放审批
  coinSendApplyReview(data, method) {
    return ajax('post', getRequestUrl('/api/SendCoins/coinSendApplyReview'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 金币道具审批 -- 道具发放审批
  propSendApplyReview(data, method) {
    return ajax('post', getRequestUrl('/api/SendCoins/propSendApplyReview'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },
}



// WEBPACK FOOTER //
// ./src/js/https/approval.js